import React from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';
import { ReactComponent as CloseCircleOutlined } from 'assets/icons/close-circle-outlined.svg';
import { ReactComponent as CheckCircleOutlined } from 'assets/icons/check-circle-outlined.svg';

const CloseButtonError = styled(CloseCircleOutlined)`
    width: 20px;
    height: 20px;
    fill: white !important;
    color: white;
    svg {
        fill: white !important;
    }
`;

const CloseButtonSuccess = styled(CheckCircleOutlined)`
    width: 20px;
    height: 20px;
    fill: white !important;
    color: white;
    svg {
        fill: white !important;
    }
`;

const ToastContainerStyled = styled(({ className }) => {
    return (
        <div className={className}>
            <ToastContainer
                transition={Slide}
                position="top-center"
                autoClose={1000}
                hideProgressBar={true}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                closeButton={({ type }) =>
                    type === 'success' ? (
                        <CloseButtonSuccess />
                    ) : (
                        <CloseButtonError />
                    )
                }
            />
        </div>
    );
})`
    .Toastify__toast-container {
    }
    .Toastify__toast-container--top-left {
    }
    .Toastify__toast-container--top-center {
    }
    .Toastify__toast-container--top-right {
    }
    .Toastify__toast-container--bottom-left {
    }
    .Toastify__toast-container--bottom-center {
    }
    .Toastify__toast-container--bottom-right {
    }
    .Toastify__toast {
        font-family: ${({ theme }) => theme.defaults.fontFamily};
        font-weight: 500;
        font-size: 13px;
        place-items: center;
        border-radius: 0.25rem;
        box-shadow: 0 0 3rem 0.125rem var(0, 0, 0, 0.2);
    }
    .Toastify__toast--rtl {
    }
    .Toastify__toast--dark {
    }
    .Toastify__toast--default {
    }
    .Toastify__toast--info {
    }
    .Toastify__toast--success {
        background-color: ${({ theme }) => theme.branding.primary.main};
    }
    .Toastify__toast--warning {
    }
    .Toastify__toast--error {
        background-color: ${({ theme }) => theme.branding.tertiary.main};
    }
    .Toastify__toast-body {
        text-align: center;
    }
    .Toastify__close-button {
    }
    .Toastify__close-button--default {
    }
    .Toastify__close-button > svg {
    }
    .Toastify__close-button:hover,
    .Toastify__close-button:focus {
    }
    .Toastify__progress-bar {
    }
    .Toastify__progress-bar--animated {
    }
    .Toastify__progress-bar--controlled {
    }
    .Toastify__progress-bar--rtl {
    }
    .Toastify__progress-bar--default {
    }
    .Toastify__progress-bar--dark {
    }
`;

export default ToastContainerStyled;
